/**
 * @generated SignedSource<<b95a973f7fa0143922d85da75afe248e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type PreviewWidgetNoteIntegrationInput = {
  providerId?: string | null;
  size: WidgetNoteSize;
  storecastId?: string | null;
};
export type PreviewWidgetTurnpikeIntegrationInput = {
  size?: WidgetIntegrationTurnpikeSize | null;
  storecastId?: string | null;
};
export type WACategoryIntegrationsQuery$variables = {
  after?: string | null;
  first?: number | null;
  noteInput: PreviewWidgetNoteIntegrationInput;
  storecastId: string;
  turnpikeInput: PreviewWidgetTurnpikeIntegrationInput;
};
export type WACategoryIntegrationsQuery$data = {
  readonly dashboard: {
    readonly previewWidgetEmployeeLeave: {
      readonly __typename: "WidgetEmployeeLeave";
      readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeLeave_widgetEmployeeLeave">;
    } | null;
    readonly previewWidgetEmployeeSchedule: {
      readonly __typename: "WidgetEmployeeSchedule";
      readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeSchedule_widgetEmployeeSchedule">;
    } | null;
    readonly previewWidgetFlourishPraiseIntegration: {
      readonly __typename: "WidgetIntegrationFlourishPraise";
      readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise">;
    } | null;
    readonly previewWidgetKPIs: ReadonlyArray<{
      readonly __typename: "WidgetKPI";
      readonly dataSource: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetKPI_widgetKPI">;
    } | null>;
    readonly previewWidgetLists: ReadonlyArray<{
      readonly __typename: "WidgetList";
      readonly dataSource: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetList_widgetList">;
    } | null>;
    readonly previewWidgetNewsfeeds: ReadonlyArray<{
      readonly __typename: "WidgetNewsfeed";
      readonly newsfeedId: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetNewsfeed_widgetNewsfeed">;
    }>;
    readonly previewWidgetNoteIntegration: ReadonlyArray<{
      readonly __typename: "WidgetNote";
      readonly id: string;
      readonly integrationId: string | null;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
    }>;
    readonly previewWidgetPushAppyIntegration: {
      readonly __typename: "WidgetIntegrationPushAppy";
      readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationPushAppy_widgetIntegrationPushAppy">;
    } | null;
    readonly previewWidgetTables: ReadonlyArray<{
      readonly __typename: "WidgetTable";
      readonly dataSource: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_table">;
    } | null>;
    readonly previewWidgetTodoOverview: {
      readonly widgets: ReadonlyArray<{
        readonly __typename: "WidgetTodoOverview";
        readonly category: {
          readonly id: string;
        } | null;
        readonly title: string;
        readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewPreview_widget">;
      }>;
    };
    readonly previewWidgetTurnpikeIntegration: {
      readonly __typename: "WidgetIntegrationTurnpike";
      readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpike_widgetIntegrationTurnpike">;
    } | null;
  };
};
export type WACategoryIntegrationsQuery = {
  response: WACategoryIntegrationsQuery$data;
  variables: WACategoryIntegrationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "turnpikeInput"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "noteInput"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationId",
  "storageKey": null
},
v12 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "storecastId",
      "variableName": "storecastId"
    }
  ],
  "kind": "ObjectValue",
  "name": "input"
},
v13 = [
  (v12/*: any*/)
],
v14 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "turnpikeInput"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataSource",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newsfeedId",
  "storageKey": null
},
v17 = [
  (v12/*: any*/),
  {
    "kind": "Literal",
    "name": "integrations",
    "value": true
  }
],
v18 = [
  (v9/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "overviewSize",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedStartAtTime",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedEndAtTime",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v26 = [
  (v10/*: any*/),
  (v25/*: any*/),
  (v9/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v31 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "thumbhash",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v28/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlExpiresAt",
        "storageKey": null
      },
      (v29/*: any*/),
      (v30/*: any*/)
    ],
    "storageKey": null
  }
],
v32 = [
  (v9/*: any*/),
  {
    "alias": "largeImage",
    "args": [
      {
        "kind": "Literal",
        "name": "minHeight",
        "value": 1080
      },
      {
        "kind": "Literal",
        "name": "minWidth",
        "value": 1080
      }
    ],
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "size",
    "plural": false,
    "selections": [
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v9/*: any*/)
    ],
    "storageKey": "size(minHeight:1080,minWidth:1080)"
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v37 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parts",
    "storageKey": null
  }
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiredToDescribeTodo",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUri",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isIssue",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoSubject",
  "kind": "LinkedField",
  "name": "subject",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubjectBreadcrumb",
      "kind": "LinkedField",
      "name": "allBreadcrumbs",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        (v39/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRoot",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v40/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v45 = [
  (v7/*: any*/),
  (v9/*: any*/)
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategoryTag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v25/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAt",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAtFormatted",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v9/*: any*/),
            (v27/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkedToViewer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Todo",
  "kind": "LinkedField",
  "name": "subTodos",
  "plural": true,
  "selections": [
    (v22/*: any*/),
    (v7/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v27/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canWrite",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isResponseCompleted",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "response",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": (v31/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TodoResponseImage",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v57 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v58 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "changeType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WACategoryIntegrationsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v6/*: any*/),
              "concreteType": "WidgetEmployeeSchedule",
              "kind": "LinkedField",
              "name": "previewWidgetEmployeeSchedule",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetEmployeeSchedule_widgetEmployeeSchedule"
                }
              ],
              "storageKey": "previewWidgetEmployeeSchedule(input:{})"
            },
            {
              "alias": null,
              "args": (v6/*: any*/),
              "concreteType": "WidgetEmployeeLeave",
              "kind": "LinkedField",
              "name": "previewWidgetEmployeeLeave",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetEmployeeLeave_widgetEmployeeLeave"
                }
              ],
              "storageKey": "previewWidgetEmployeeLeave(input:{})"
            },
            {
              "alias": null,
              "args": (v8/*: any*/),
              "concreteType": "WidgetNote",
              "kind": "LinkedField",
              "name": "previewWidgetNoteIntegration",
              "plural": true,
              "selections": [
                (v7/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetNote_widgetNote"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v13/*: any*/),
              "concreteType": "WidgetIntegrationPushAppy",
              "kind": "LinkedField",
              "name": "previewWidgetPushAppyIntegration",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetIntegrationPushAppy_widgetIntegrationPushAppy"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v14/*: any*/),
              "concreteType": "WidgetIntegrationTurnpike",
              "kind": "LinkedField",
              "name": "previewWidgetTurnpikeIntegration",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetIntegrationTurnpike_widgetIntegrationTurnpike"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v13/*: any*/),
              "concreteType": "WidgetIntegrationFlourishPraise",
              "kind": "LinkedField",
              "name": "previewWidgetFlourishPraiseIntegration",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v13/*: any*/),
              "concreteType": "WidgetKPI",
              "kind": "LinkedField",
              "name": "previewWidgetKPIs",
              "plural": true,
              "selections": [
                (v7/*: any*/),
                (v10/*: any*/),
                (v15/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetKPI_widgetKPI"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v13/*: any*/),
              "concreteType": "WidgetNewsfeed",
              "kind": "LinkedField",
              "name": "previewWidgetNewsfeeds",
              "plural": true,
              "selections": [
                (v7/*: any*/),
                (v10/*: any*/),
                (v16/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetNewsfeed_widgetNewsfeed"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v17/*: any*/),
              "concreteType": "PreviewWidgetTodoOverviewPayload",
              "kind": "LinkedField",
              "name": "previewWidgetTodoOverview",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WidgetTodoOverview",
                  "kind": "LinkedField",
                  "name": "widgets",
                  "plural": true,
                  "selections": [
                    (v7/*: any*/),
                    (v10/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TodoCategory",
                      "kind": "LinkedField",
                      "name": "category",
                      "plural": false,
                      "selections": (v18/*: any*/),
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "WidgetTodoOverviewPreview_widget"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v13/*: any*/),
              "concreteType": "WidgetList",
              "kind": "LinkedField",
              "name": "previewWidgetLists",
              "plural": true,
              "selections": [
                (v7/*: any*/),
                (v10/*: any*/),
                (v15/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetList_widgetList"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v13/*: any*/),
              "concreteType": "WidgetTable",
              "kind": "LinkedField",
              "name": "previewWidgetTables",
              "plural": true,
              "selections": [
                (v7/*: any*/),
                (v10/*: any*/),
                (v15/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetTable_table"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WACategoryIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "WidgetEmployeeSchedule",
            "kind": "LinkedField",
            "name": "previewWidgetEmployeeSchedule",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employeesWithShifts",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeShift",
                    "kind": "LinkedField",
                    "name": "shifts",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      (v9/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "durationSeconds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAtSecondsFromMidnight",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeScheduleType",
                        "kind": "LinkedField",
                        "name": "scheduleType",
                        "plural": false,
                        "selections": (v26/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeScheduleSecondaryType",
                        "kind": "LinkedField",
                        "name": "secondaryScheduleType",
                        "plural": false,
                        "selections": (v26/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "previewWidgetEmployeeSchedule(input:{})"
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "WidgetEmployeeLeave",
            "kind": "LinkedField",
            "name": "previewWidgetEmployeeLeave",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetEmployeeLeaveItem",
                "kind": "LinkedField",
                "name": "employeesOnLeave",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employee",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isPublicAndInternalImage"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publicImageUrl",
                                "storageKey": null
                              }
                            ],
                            "type": "PublicImage",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v31/*: any*/),
                            "type": "Image",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeShift",
                    "kind": "LinkedField",
                    "name": "shifts",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endAt",
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LeaveReason",
                        "kind": "LinkedField",
                        "name": "leaveReason",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "leaveReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "leaveCode",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "previewWidgetEmployeeLeave(input:{})"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "WidgetNote",
            "kind": "LinkedField",
            "name": "previewWidgetNoteIntegration",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editingMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrgNote",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetNotePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v32/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "includedInSlideshow",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backgroundColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "version",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontStyle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageScale",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateX",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateY",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remoteImageURL",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "containImage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteSize",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "WidgetIntegrationPushAppy",
            "kind": "LinkedField",
            "name": "previewWidgetPushAppyIntegration",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetIntegrationPushAppyLeaderboardItem",
                "kind": "LinkedField",
                "name": "leaderboard",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "goal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "progress",
                    "storageKey": null
                  },
                  (v33/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "WidgetIntegrationTurnpike",
            "kind": "LinkedField",
            "name": "previewWidgetTurnpikeIntegration",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "turnpikeSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationTurnpike",
                "kind": "LinkedField",
                "name": "integration",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationTurnpikeSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "acceptedTimeAverageInMs",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accepted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unanswered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rejected",
                        "storageKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "WidgetIntegrationFlourishPraise",
            "kind": "LinkedField",
            "name": "previewWidgetFlourishPraiseIntegration",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v9/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetIntegrationFlourishPraiseLeaderboardItem",
                "kind": "LinkedField",
                "name": "flourishTeams",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "praise",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "WidgetKPI",
            "kind": "LinkedField",
            "name": "previewWidgetKPIs",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/),
              (v15/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetKPITile",
                "kind": "LinkedField",
                "name": "tiles",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subtitle",
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetKPITileTrend",
                    "kind": "LinkedField",
                    "name": "trends",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "change",
                        "storageKey": null
                      },
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "compareValue",
                        "storageKey": null
                      },
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "graph",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v35/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v37/*: any*/),
                        "type": "WidgetKPITileGraphBar",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v37/*: any*/),
                        "type": "WidgetKPITileGraphSlider",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "negative",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "positive",
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetKPITileGraphRegions",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetKPITileGraphGaugePart",
                            "kind": "LinkedField",
                            "name": "gaugeParts",
                            "plural": true,
                            "selections": [
                              (v25/*: any*/),
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mode",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetKPITileGraphGaugeIndicator",
                            "kind": "LinkedField",
                            "name": "indicators",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              (v34/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetKPITileGraphGauge",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "WidgetNewsfeed",
            "kind": "LinkedField",
            "name": "previewWidgetNewsfeeds",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationNewsfeed",
                "kind": "LinkedField",
                "name": "newsfeed",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetNewsfeedPost",
                "kind": "LinkedField",
                "name": "posts",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": (v32/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "PreviewWidgetTodoOverviewPayload",
            "kind": "LinkedField",
            "name": "previewWidgetTodoOverview",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetTodoOverview",
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subscriptionKey",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoSubjectGroup",
                            "kind": "LinkedField",
                            "name": "subjectGroups",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TodoSubject",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TodoSubjectBreadcrumb",
                                    "kind": "LinkedField",
                                    "name": "allBreadcrumbs",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v39/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v40/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Todo",
                                "kind": "LinkedField",
                                "name": "todos",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  (v42/*: any*/),
                                  (v22/*: any*/),
                                  (v10/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": (v45/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "files",
                                    "plural": true,
                                    "selections": (v45/*: any*/),
                                    "storageKey": null
                                  },
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetTodoOverviewContentMediumGrouped",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "todoContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": (v57/*: any*/),
                            "concreteType": "TodoConnection",
                            "kind": "LinkedField",
                            "name": "todos",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TodoEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Todo",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v42/*: any*/),
                                      (v22/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formattedBody",
                                        "storageKey": null
                                      },
                                      (v38/*: any*/),
                                      (v43/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StoreZonedDate",
                                        "kind": "LinkedField",
                                        "name": "createdAtDate",
                                        "plural": false,
                                        "selections": (v58/*: any*/),
                                        "storageKey": null
                                      },
                                      (v44/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "images",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "minHeight",
                                                "value": 699
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "minWidth",
                                                "value": 699
                                              }
                                            ],
                                            "concreteType": "ImageSize",
                                            "kind": "LinkedField",
                                            "name": "size",
                                            "plural": false,
                                            "selections": [
                                              (v28/*: any*/),
                                              (v9/*: any*/)
                                            ],
                                            "storageKey": "size(minHeight:699,minWidth:699)"
                                          },
                                          (v9/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StoreProduct",
                                        "kind": "LinkedField",
                                        "name": "linkedProducts",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v27/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "partNumber",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageUrl",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "files",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v27/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "formattedSize",
                                            "storageKey": null
                                          },
                                          (v36/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FilePage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": (v18/*: any*/),
                                            "storageKey": null
                                          },
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v46/*: any*/),
                                      (v47/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v51/*: any*/),
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v54/*: any*/),
                                      (v55/*: any*/),
                                      (v56/*: any*/),
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__id",
                                    "storageKey": null
                                  }
                                ]
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v57/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "WidgetTodoOverviewContentMedium__todos",
                            "kind": "LinkedHandle",
                            "name": "todos"
                          }
                        ],
                        "type": "WidgetTodoOverviewContentMedium",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v18/*: any*/),
                        "type": "WidgetTodoOverviewContentMediumGrouped",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "WidgetList",
            "kind": "LinkedField",
            "name": "previewWidgetLists",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/),
              (v15/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetListSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetListItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rightText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rightTextSuffix",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "info",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isWidgetListItemInfo"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v58/*: any*/),
                            "type": "StoreZonedDate",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "italic",
                                "storageKey": null
                              }
                            ],
                            "type": "WidgetListItemInfoText",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "WidgetTable",
            "kind": "LinkedField",
            "name": "previewWidgetTables",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/),
              (v15/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetTableSheet",
                "kind": "LinkedField",
                "name": "sheets",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetTableColumn",
                    "kind": "LinkedField",
                    "name": "columns",
                    "plural": true,
                    "selections": [
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetTableSection",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetTableRow",
                        "kind": "LinkedField",
                        "name": "headerRow",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetTableCell",
                            "kind": "LinkedField",
                            "name": "cells",
                            "plural": true,
                            "selections": [
                              (v34/*: any*/),
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetTableRow",
                        "kind": "LinkedField",
                        "name": "rows",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetTableCell",
                            "kind": "LinkedField",
                            "name": "cells",
                            "plural": true,
                            "selections": [
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sortValue",
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "093df0925b3a858ee7c524c2817e0b31",
    "id": null,
    "metadata": {},
    "name": "WACategoryIntegrationsQuery",
    "operationKind": "query",
    "text": "query WACategoryIntegrationsQuery(\n  $noteInput: PreviewWidgetNoteIntegrationInput!\n  $turnpikeInput: PreviewWidgetTurnpikeIntegrationInput!\n  $storecastId: ID!\n  $first: Int\n  $after: String\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetEmployeeSchedule(input: {}) {\n      __typename\n      ...WidgetEmployeeSchedule_widgetEmployeeSchedule\n      id\n    }\n    previewWidgetEmployeeLeave(input: {}) {\n      __typename\n      ...WidgetEmployeeLeave_widgetEmployeeLeave\n      id\n    }\n    previewWidgetNoteIntegration(input: $noteInput) {\n      __typename\n      id\n      title\n      integrationId\n      ...WidgetNote_widgetNote\n    }\n    previewWidgetPushAppyIntegration(input: {storecastId: $storecastId}) {\n      __typename\n      ...WidgetIntegrationPushAppy_widgetIntegrationPushAppy\n      id\n    }\n    previewWidgetTurnpikeIntegration(input: $turnpikeInput) {\n      __typename\n      ...WidgetIntegrationTurnpike_widgetIntegrationTurnpike\n      id\n    }\n    previewWidgetFlourishPraiseIntegration(input: {storecastId: $storecastId}) {\n      __typename\n      ...WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise\n      id\n    }\n    previewWidgetKPIs(input: {storecastId: $storecastId}) {\n      __typename\n      title\n      dataSource\n      ...WidgetKPI_widgetKPI\n      id\n    }\n    previewWidgetNewsfeeds(input: {storecastId: $storecastId}) {\n      __typename\n      title\n      newsfeedId\n      ...WidgetNewsfeed_widgetNewsfeed\n      id\n    }\n    previewWidgetTodoOverview(input: {storecastId: $storecastId}, integrations: true) {\n      widgets {\n        __typename\n        title\n        category {\n          id\n        }\n        ...WidgetTodoOverviewPreview_widget\n        id\n      }\n    }\n    previewWidgetLists(input: {storecastId: $storecastId}) {\n      __typename\n      title\n      dataSource\n      ...WidgetList_widgetList\n      id\n    }\n    previewWidgetTables(input: {storecastId: $storecastId}) {\n      __typename\n      title\n      dataSource\n      ...WidgetTable_table\n      id\n    }\n    id\n  }\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedProducts_products on StoreProduct {\n  id\n  name\n  partNumber\n  imageUrl\n}\n\nfragment NewsfeedNative_widgetNewsfeed on WidgetNewsfeed {\n  id\n  title\n  posts {\n    ...WidgetNewsfeedPost_widgetNewsfeedPost\n  }\n}\n\nfragment NewsfeedWeb_widgetNewsfeed on WidgetNewsfeed {\n  posts {\n    ...WidgetNewsfeedPost_widgetNewsfeedPost\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment SignalDetailFiles_files on File {\n  id\n  name\n  formattedSize\n  type\n  pages {\n    id\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment Tile_kpiTile on WidgetKPITile {\n  title\n  subtitle\n  value\n  unit\n  trends {\n    change\n    label\n    compareValue\n    type\n  }\n  graph {\n    __typename\n    label\n    ... on WidgetKPITileGraphBar {\n      __typename\n      ...Tile_kpiTileGraphBar\n    }\n    ... on WidgetKPITileGraphSlider {\n      __typename\n      ...Tile_kpiTileGraphSlider\n    }\n    ... on WidgetKPITileGraphRegions {\n      __typename\n      ...Tile_kpiTileGraphRegions\n    }\n    ... on WidgetKPITileGraphGauge {\n      __typename\n      ...Tile_kpiTileGraphGauge\n    }\n  }\n}\n\nfragment Tile_kpiTileGraphBar on WidgetKPITileGraphBar {\n  parts\n}\n\nfragment Tile_kpiTileGraphGauge on WidgetKPITileGraphGauge {\n  gaugeParts {\n    color\n    value\n    mode\n  }\n  indicators {\n    type\n    value\n  }\n}\n\nfragment Tile_kpiTileGraphRegions on WidgetKPITileGraphRegions {\n  negative\n  positive\n}\n\nfragment Tile_kpiTileGraphSlider on WidgetKPITileGraphSlider {\n  parts\n}\n\nfragment TodoDetailContentMain_todo on Todo {\n  id\n  title\n  formattedBody\n  body\n  isIssue\n  ...TodoEditNewMainCreationInfo\n  ...TodoDetailImages_todo\n  linkedProducts {\n    ...LinkedProducts_products\n    id\n  }\n  files {\n    ...SignalDetailFiles_files\n    id\n  }\n}\n\nfragment TodoDetailImages_todo on Todo {\n  images {\n    size(minHeight: 699, minWidth: 699) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment TodoEditNewMainCreationInfo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n}\n\nfragment TodoOverviewListItemMediumDescription_Todo on Todo {\n  title\n  isIssue\n  subject {\n    ...TodoSubject_TodoSubject\n    ...TodoSubjectExcludeRoot_TodoSubject\n  }\n  images {\n    __typename\n    id\n  }\n  files {\n    __typename\n    id\n  }\n}\n\nfragment TodoOverviewListItemMediumFooter_Todo on Todo {\n  tags {\n    id\n    color\n    title\n  }\n  ...WidgetTodoListItemDeadline_todo\n  expireAt\n  assignedRoles {\n    role {\n      name\n      employees {\n        id\n        name\n        isLinkedToViewer\n        workStatus\n      }\n      id\n    }\n    id\n  }\n  subTodos {\n    status\n    __typename\n    id\n  }\n  assigned {\n    employee {\n      name\n      id\n    }\n    id\n  }\n  commentCount\n}\n\nfragment TodoOverviewListItemMediumStatusAndPrio_Todo on Todo {\n  canWrite\n  id\n  status\n  priority\n  expireAt\n  isResponseCompleted\n  ordinal\n  response {\n    __typename\n    ... on TodoResponseNumber {\n      __typename\n    }\n    ... on TodoResponseText {\n      __typename\n    }\n    ... on TodoResponseImage {\n      __typename\n      images {\n        id\n        ...Image_image\n      }\n    }\n  }\n}\n\nfragment TodoOverviewListItemMedium_Todo on Todo {\n  id\n  ...TodoOverviewListItemMediumDescription_Todo\n  ...TodoOverviewListItemMediumFooter_Todo\n  ...TodoOverviewListItemMediumStatusAndPrio_Todo\n}\n\nfragment TodoSubjectExcludeRoot_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    isRoot\n    requiredToDescribeTodo\n  }\n}\n\nfragment TodoSubjectIcon_TodoSubject on TodoSubject {\n  icon\n  iconUri\n}\n\nfragment TodoSubject_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    requiredToDescribeTodo\n  }\n  ...TodoSubjectIcon_TodoSubject\n}\n\nfragment WidgetEmployeeLeaveItem_item on WidgetEmployeeLeaveItem {\n  id\n  employee {\n    id\n    name\n    image {\n      __typename\n      ...ImagePublicOrPrivate_image\n      ... on Image {\n        id\n      }\n    }\n  }\n  shifts {\n    id\n    startAt\n    endAt\n    formattedStartAtTime\n    formattedEndAtTime\n    leaveReason {\n      id\n      leaveReason\n      leaveCode\n    }\n  }\n}\n\nfragment WidgetEmployeeLeave_widgetEmployeeLeave on WidgetEmployeeLeave {\n  id\n  title\n  employeesOnLeave {\n    id\n    ...WidgetEmployeeLeaveItem_item\n  }\n}\n\nfragment WidgetEmployeeScheduleIcon_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  provider\n}\n\nfragment WidgetEmployeeScheduleShiftBar on EmployeeShift {\n  status\n  formattedStartAtTime\n  formattedEndAtTime\n  durationSeconds\n  startAtSecondsFromMidnight\n  scheduleType {\n    title\n    color\n    id\n  }\n  secondaryScheduleType {\n    title\n    color\n    id\n  }\n}\n\nfragment WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee on Employee {\n  name\n}\n\nfragment WidgetEmployeeScheduleShiftsEmployee_employee on Employee {\n  id\n  ...WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee\n  shifts {\n    id\n    ...WidgetEmployeeScheduleShiftBar\n  }\n}\n\nfragment WidgetEmployeeSchedule_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  id\n  overviewSize\n  teams {\n    id\n  }\n  ...WidgetEmployeeScheduleIcon_widgetEmployeeSchedule\n  employeesWithShifts {\n    id\n    shifts {\n      status\n      id\n    }\n    ...WidgetEmployeeScheduleShiftsEmployee_employee\n  }\n}\n\nfragment WidgetIntegrationFlourishPraiseLeaderboardItem on WidgetIntegrationFlourishPraiseLeaderboardItem {\n  id\n  praise\n  title\n}\n\nfragment WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise on WidgetIntegrationFlourishPraise {\n  id\n  overviewSize\n  flourishTeams {\n    id\n    ...WidgetIntegrationFlourishPraiseLeaderboardItem\n  }\n}\n\nfragment WidgetIntegrationPushAppy_widgetIntegrationPushAppy on WidgetIntegrationPushAppy {\n  id\n  title\n  overviewSize\n  leaderboard {\n    id\n    title\n    goal\n    progress\n    total\n  }\n}\n\nfragment WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n  total\n}\n\nfragment WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  total\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n}\n\nfragment WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  total\n}\n\nfragment WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpike_widgetIntegrationTurnpike on WidgetIntegrationTurnpike {\n  id\n  turnpikeSize\n  integration {\n    summary {\n      ...WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary\n      ...WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary\n    }\n    id\n  }\n}\n\nfragment WidgetKPI_widgetKPI on WidgetKPI {\n  id\n  title\n  dataSource\n  tiles {\n    ...Tile_kpiTile\n  }\n}\n\nfragment WidgetList_listItemInfo on WidgetListItemInfo {\n  __isWidgetListItemInfo: __typename\n  __typename\n  ... on StoreZonedDate {\n    storeFormattedDate(style: DEFAULT)\n  }\n  ... on WidgetListItemInfoText {\n    text\n    italic\n  }\n}\n\nfragment WidgetList_widgetList on WidgetList {\n  id\n  title\n  dataSource\n  sections {\n    title\n    items {\n      title\n      rightText\n      rightTextSuffix\n      info {\n        __typename\n        ...WidgetList_listItemInfo\n      }\n    }\n  }\n}\n\nfragment WidgetNewsfeedPost_widgetNewsfeedPost on WidgetNewsfeedPost {\n  title\n  body\n  images {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  date\n}\n\nfragment WidgetNewsfeed_widgetNewsfeed on WidgetNewsfeed {\n  title\n  newsfeed {\n    provider\n    id\n  }\n  ...NewsfeedNative_widgetNewsfeed\n  ...NewsfeedWeb_widgetNewsfeed\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNote_widgetNote on WidgetNote {\n  id\n  note {\n    editingMode\n    isOrgNote\n    pages {\n      id\n    }\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment WidgetTable_cell on WidgetTableCell {\n  value\n  changeType\n}\n\nfragment WidgetTable_row on WidgetTableRow {\n  cells {\n    ...WidgetTable_cell\n  }\n}\n\nfragment WidgetTable_section on WidgetTableSection {\n  headerRow {\n    ...WidgetTable_row\n  }\n  rows {\n    cells {\n      value\n      sortValue\n    }\n    ...WidgetTable_row\n  }\n}\n\nfragment WidgetTable_sheet on WidgetTableSheet {\n  title\n  columns {\n    label\n  }\n  sections {\n    ...WidgetTable_section\n  }\n}\n\nfragment WidgetTable_table on WidgetTable {\n  id\n  title\n  dataSource\n  sheets {\n    title\n    ...WidgetTable_sheet\n  }\n}\n\nfragment WidgetTodoListItemDeadline_todo on Todo {\n  expireAt\n  expireAtFormatted\n}\n\nfragment WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped on WidgetTodoOverviewContentMediumGrouped {\n  __typename\n  id\n  subscriptionKey\n  subjectGroups {\n    subject {\n      ...TodoSubject_TodoSubject\n    }\n    todos {\n      id\n      ordinal\n      status\n      ...TodoOverviewListItemMedium_Todo\n    }\n  }\n}\n\nfragment WidgetTodoOverviewContentMediumPaginated on WidgetTodoOverview {\n  teams {\n    id\n  }\n  category {\n    id\n  }\n  todoContent: content {\n    __typename\n    ... on WidgetTodoOverviewContentMedium {\n      todos(first: $first, after: $after) {\n        edges {\n          node {\n            id\n            ordinal\n            status\n            ...TodoDetailContentMain_todo\n            ...TodoOverviewListItemMedium_Todo\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    ... on WidgetTodoOverviewContentMediumGrouped {\n      id\n    }\n  }\n  id\n}\n\nfragment WidgetTodoOverviewPreview_widget on WidgetTodoOverview {\n  id\n  title\n  category {\n    id\n    title\n  }\n  teams {\n    id\n  }\n  content {\n    __typename\n    ... on WidgetTodoOverviewContentMediumGrouped {\n      __typename\n      ...WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped\n      id\n    }\n    ... on WidgetTodoOverviewContentMedium {\n      __typename\n    }\n  }\n  ...WidgetTodoOverviewContentMediumPaginated\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0a5ac84c3548fec7d8df11047101458";

export default node;
